import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Actions, ofActionDispatched, Select, Store} from '@ngxs/store';
import {PaymentKeyState} from '../shared/map.state';
import {Observable, throwError} from 'rxjs';
import {ThemePalette} from '@angular/material/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {Session} from '../../interfaces/session-data';
import {BankOptions} from '../../interfaces/bank-options';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {BreakpointObserver} from '@angular/cdk/layout';
import {SetPaymentStepOtt} from '../shared/map.actions';
import {catchError, filter} from 'rxjs/operators';
import {OttVoucherService} from '../../services/ott-voucher/ott-voucher.service';
import {TransactionService} from '../../services/transaction/transaction.service';

@Component({
  selector: 'app-ott-voucher',
  templateUrl: './ott-voucher.component.html',
  styleUrls: ['./ott-voucher.component.scss']
})
export class OttVoucherComponent implements OnInit {

  paymentOptionsLoadedJustify;

  // ngxs-store
  @Select(PaymentKeyState) paymentkey$: Observable<object>;

  // box-shadow
  public boxShadow = '0px 6px 12px 0px rgba(0,0,0,0.5 )';

  // listen for state change

  // Loader
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;
  transactionChargeSent: Boolean = false;

  // session
  session: Session;

  // payment
  paymentMethod: string;
  paymentMethodStyling;
  paymentMethodImg: string = "";
  paymentConfirm: Boolean = false;
  paymentOptions: BankOptions;

  loading: boolean = true;
  hidePgLogo = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ottVoucherService: OttVoucherService,
    private breakpointObserver: BreakpointObserver,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef,
    private actions$: Actions,
    private transactionService: TransactionService) {
    this.paymentMethod = 'ott_voucher';
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_step_one.png`;
    sessionStorage.setItem('selected-payment', 'ott_voucher');

    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.loading = false;
      }
    });

    this.actions$
      .pipe(ofActionDispatched(SetPaymentStepOtt))
      .subscribe(({ payload }) => this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_${payload.toLowerCase()}.png`);
    }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    if (this.router.routerState.snapshot.url.indexOf(`${this.paymentMethod}/`) === -1) {
      this.router.navigate(['input'], { relativeTo: this.route });
    } else {
      this.loading = false;
    }
    this.paymentkey$.pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  };

  goBack() {
    this.router.navigate(['virtual']);
    sessionStorage.setItem("goBack", "true");
  }

}
